module.exports = {
    api_endpoint: 'https://shares.overxls.com',
  };